<div class="af-field">
  <label class="af-label" [attr.for]="inputId">{{ label }}</label>
  <div class="pf-wrap">
    <input
      class="af-input pf-input"
      [id]="inputId"
      [type]="visible ? 'text' : 'password'"
      [formControl]="control"
      [attr.autocomplete]="autocomplete"
      [class.is-invalid]="!!errorText"
      [attr.aria-invalid]="!!errorText"
      [attr.aria-describedby]="inputId + '-help'"
      autocapitalize="off"
      spellcheck="false"
    />
    <button
      type="button"
      class="pf-eye"
      (click)="toggle()"
      [attr.aria-label]="visible ? 'Hide password' : 'Show password'"
      [attr.aria-pressed]="visible"
      [title]="visible ? 'Hide password' : 'Show password'"
    >
      @if (visible) {
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M3 3l18 18M10.6 10.6a2 2 0 0 0 2.8 2.8M9.4 5.2A9.8 9.8 0 0 1 12 5c5 0 8.5 4.2 9.5 7-.4 1.1-1.2 2.5-2.4 3.8M6.2 6.6C4.4 7.9 3.1 9.8 2.5 12c1 2.8 4.5 7 9.5 7 1.6 0 3-.4 4.3-1"/>
        </svg>
      } @else {
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M2.5 12C3.5 9.2 7 5 12 5s8.5 4.2 9.5 7c-1 2.8-4.5 7-9.5 7s-8.5-4.2-9.5-7z"/><circle cx="12" cy="12" r="3"/>
        </svg>
      }
    </button>
  </div>

  <div [id]="inputId + '-help'">
    @if (showStrength) {
      <div class="pf-meter" [attr.data-score]="score" aria-hidden="true">
        <span></span><span></span><span></span><span></span>
      </div>
      <div class="pf-meta">
        <ul class="pf-rules">
          <li [class.is-met]="longEnough">8+ characters</li>
          <li [class.is-met]="hasLetter">Not only numbers</li>
        </ul>
        @if (value) {
          <span class="pf-score" [attr.data-score]="score" aria-live="polite">{{ scoreLabel }}</span>
        }
      </div>
    }
    @if (errorText) {
      <p class="af-error" role="alert">{{ errorText }}</p>
    }
  </div>
</div>
